<div class="report-cardlist">
  <div class="user-list" (click)="onClick()">
    <div class="initials-container" [ngStyle]="{ 'background-color': color }">
      @if (user()?.isDistributionGroup) {
        <span>{{ (user()?.firstName || '--').substring(0, 2) | uppercase }}</span>
      } @else {
        <span>{{ (user()?.firstName || '-')[0] | uppercase }}{{ (user()?.lastName || '-')[0] | uppercase }}</span>
      }
    </div>
    <div class="userInfo">
      <div class="username-pinned-row">
        @if (user()?.isDistributionGroup) {
          <span class="username"><strong>{{'admin.usergroup.groupName' | translate}}:</strong> {{ user()?.firstName || '-' }}</span>
        } @else {
          <span class="username">{{ user()?.firstName || '-' }} {{ user()?.lastName || '-' }}</span>
        }
        @if (showPinIcon()) {
          <span
            class="pinnedIIcon"
            (click)="onPinClick($event, isPinned())"
            [matTooltip]="isPinned() ? ('reports.unpinContact' | translate) : ('reports.pinContact' | translate)"
            >
            <span class="icon-pin-icon" [ngClass]="{ 'pin-green': isPinned(), 'pin-grey': !isPinned() }"></span>
          </span>
        }
      </div>
      @if (user()?.isDistributionGroup) {
        <div class="group-user-count">
          {{ (user()?.distributionGroupUsers?.length || 0) }} {{ ((user()?.distributionGroupUsers?.length || 0) === 1 ? 'admin.privacyControl.user' : 'admin.usergroup.users') | translate }}
        </div>
        <div class="email">
          {{ user()?.emailAddress || '-' }}
          @if ((user()?.distributionGroupUsers?.length || 0) > 1) {
            <a class="more-link" (click)="onShowGroupMembers($event)">+{{ (user()?.distributionGroupUsers?.length || 0) - 1 }} {{ 'admin.usergroup.more' | translate }}</a>
          }
        </div>
      } @else {
        <div 
          class="email" 
          [matTooltip]="user()?.fullEmailList || ''"
          [matTooltipDisabled]="!user()?.fullEmailList"
          matTooltipPosition="below"
        >
          {{ user()?.emailAddress || '-' }}
        </div>
        @if (isActiveUser() != null) {
          <div class="status" [ngClass]="isActiveUser() ? 'status--active' : 'status--inactive'">
            <span
              >{{ 'recordsSearch.status' | translate }}:
              {{ (isActiveUser() ? 'recordsSearch.active' : 'recordsSearch.inactive') | translate }}
            </span>
          </div>
        }
        @if (isSpaceEntity()) {
          <div class="phone-select" (click)="$event.stopPropagation()">
            @if (user()?.phone?.length) {
              <p-multiSelect
                [options]="user()?.phone"
                optionLabel="phone_type_desc"
                optionValue="id"
                [(ngModel)]="selectedPhones"
                (onChange)="onPhoneSelectionChange($event)"
                placeholder="Select phone numbers"
                [showHeader]="false"
                maxSelectedLabels="0"
                [style]="{ 'min-width': '200px' }"
                styleClass="contact-phone-multiselect"
                >
                <ng-template pTemplate="item" let-phone>
                  <div>{{ phone.phone_type_desc }} - {{ phone.phone_number }}</div>
                </ng-template>
              </p-multiSelect>
            }
            @if (!user()?.phone?.length) {
              <span class="no-phone">No phone numbers available</span>
            }
          </div>
        }
      }
    </div>
    <div class="assign-bgcolor" [ngClass]="{ 'miq-only': isOnMIQ() }">
      <div class="assignCheck">
        <div>
          <mat-checkbox [checked]="selected()"></mat-checkbox>
        </div>
        @if (isOnMIQ() != null) {
          <div class="contactcard-icon">
            @if (isOnMIQ()) {
              <label class="miq-icon">{{ 'shared.miq' | translate }}</label>
            }
            @if (!isOnMIQ()) {
              <mat-icon>cloud_queue</mat-icon>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
